(function () {
  function initInfiniteScroll(root) {
    if (root.dataset.infiniteScrollBound === 'true') return;
    root.dataset.infiniteScrollBound = 'true';

    var sectionId = root.getAttribute('data-section-id');
    var loading = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) loadNext();
      });
    }, { rootMargin: '600px 0px' });

    function setNextUrl(url) {
      if (url) {
        root.setAttribute('data-next-url', url);
      } else {
        root.removeAttribute('data-next-url');
        observer.unobserve(root);
      }
    }

    function loadNext() {
      var nextUrl = root.getAttribute('data-next-url');
      if (!nextUrl || loading) return;
      loading = true;
      root.classList.add('is-loading');

      var separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
      var fetchUrl = nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

      fetch(fetchUrl)
        .then(function (response) {
          return response.ok ? response.text() : Promise.reject(new Error('Bad response'));
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newList = doc.getElementById('ap_productlist');
          var list = document.getElementById('ap_productlist');
          var newSentinel = doc.querySelector('[data-infinite-scroll]');

          if (newList && list) {
            while (newList.firstElementChild) {
              list.appendChild(newList.firstElementChild);
            }
          }

          setNextUrl(newSentinel ? newSentinel.getAttribute('data-next-url') : null);
        })
        .catch(function () {
          // Leave data-next-url in place so the next scroll/intersection retries.
        })
        .finally(function () {
          loading = false;
          root.classList.remove('is-loading');
        });
    }

    observer.observe(root);
  }

  function scan(target) {
    (target || document).querySelectorAll('[data-infinite-scroll]').forEach(initInfiniteScroll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan();
    });
  } else {
    scan();
  }

  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-infinite-scroll]')) initInfiniteScroll(node);
        if (node.querySelectorAll) scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
